export const OPTIMIZER_DEFAULT_RANGE_DAYS = 8
